import { Link, useLocation, useParams } from "react-router-dom";
import { Comments } from "../components/comments/Comments";
import { Layout } from "../components/layout/Layout";
import { WikiArticleLayout } from "../components/layout/WikiArticleLayout";
import { ArticleBody } from "../components/posts/ArticleBody";
import { RelatedPosts } from "../components/posts/RelatedPosts";
import { JsonLd } from "../components/seo/JsonLd";
import { SEO } from "../components/seo/SEO";
import { articleSchema, breadcrumbSchema, faqPageSchema } from "../components/seo/schema";
import { site } from "../data/site";
import { getPostBySlug, isPreviewEnabled, isPublished } from "../lib/posts";
import { NotFound } from "./NotFound";

export function PostPage() {
  const { slug = "" } = useParams();
  const location = useLocation();
  const post = getPostBySlug(slug);
  const previewEnabled = isPreviewEnabled(location.search);

  if (!post || (!isPublished(post) && !previewEnabled)) {
    return <NotFound />;
  }

  return (
    <Layout fullWidth>
      <SEO title={`${post.title} - ${site.name}`} description={post.excerpt} canonical={post.absoluteUrl} />
      <JsonLd
        data={[
          articleSchema(post),
          breadcrumbSchema([
            { name: "Home", url: "/" },
            { name: post.category, url: post.categoryUrl },
            { name: post.title, url: post.url }
          ]),
          faqPageSchema(post)
        ]}
      />

      {previewEnabled && !isPublished(post) ? (
        <div className="preview-banner" role="status">
          Preview mode: this scheduled article is hidden from public lists and sitemap.
        </div>
      ) : null}

      <nav className="breadcrumbs" aria-label="Breadcrumbs">
        <Link to="/">Home</Link>
        <span>/</span>
        <Link to={post.categoryUrl}>{post.category}</Link>
        <span>/</span>
        <span>{post.title}</span>
      </nav>

      <WikiArticleLayout
        post={post}
        related={<RelatedPosts post={post} />}
        comments={<Comments postSlug={post.slug} />}
      >
        <ArticleBody post={post} />
      </WikiArticleLayout>
    </Layout>
  );
}
